<section id="section-1">
  <div class="titulo-aluno-empresario">
    <h1 class="aluno-empresario">de aluno a empresário</h1>
    <h2 class="aluno-empresario-sub">
      conheça algumas das hístorias de sucesso do projeto educere
    </h2>
  </div>
  <span class="linha-divisao"></span>
  <div class="exemplos-alunos">
    <div class="row pt-5">
      <div class="col-md-2">
        <img
          class="imagem-aluno"
          src="assets/imagens/francisco-reigota.jpg"
          alt=""
        />
      </div>
      <div class="col-md-10">
        <h3>francisco reigota</h3>
        <h4>
          Sócio fundador da saubern e sócio proprietario da Vollenz Reabilitação
        </h4>
        <div class="texto-aluno">
          Francisco Reigota, o Chico, ingressou na Fundação educere no ano de
          2000, aos 15 anos de idade. Começou aprendendo eletrônica mas acabou
          se aprofundando na área de mecânica, especificamente com o
          desenvolvimento de equipamentos médicos.
          <br /><br />
          Em 2002, com apenas 18 anos e junto com três sócios. Chico fundou a
          empresa Saubem, dedicando-se ao desenvolvimento do primeiro
          equipamento da empresa, uma reprocessadora automática de filtros de
          hemodiálise, cujo lançamento viabilizou a reutilização de filtros de
          hemodiálise no Brasil.
          <br /><br />
          A experiência adquirida com esse projeto, inspirou Chico a desenvolver
          novos produtos, especialmente na linha de tratamento de água, o que
          levou a empresa para o mercado internacional exportando seus produtos
          para 6 países, de 2017 2020 Chico assumiu a presidência executiva da
          Fundação Educere contribuindo com a sua experiência de ex-aluno e de
          empresário incubado para uma nova fase da instituição. Em 2019 após
          uma sequência de anos em crescimento, a empresa Saubem foi adquirida
          pela maior companhia global do setor de hemodiálise, a empresa alemã
          Fresenius.
          <br /><br /><br /><br />
          Atualmente, Francisco Rigota atua no desenvolvimento de novos produtos
          na empresa Vollenz Reabilitação, da qual é sócio proprietario.
        </div>
      </div>
    </div>
    <div class="row pt-5">
      <div class="col-md-2">
        <img
          class="imagem-aluno"
          src="assets/imagens/sidmar-rocha.jpg"
          alt=""
        />
      </div>
      <div class="col-md-10">
        <h3>sidimar rocha dos santos</h3>
        <h4>Sócio Fundador da Lizze e Petlizze Equipamentos</h4>
        <div class="texto-aluno">
          Sidimar Rocha dos Santos, um garoto timido e de origem humilde, entrou
          na Fundação Educere aos 14 anos de idade para aprender eletrônica
          Porém, logo se encantou com ideia de um dia ter sua própria empresa.
          Com 16 anos, foi trabalhar na Cristófoli Biossegurança passando por
          vários setores da empresa o que lhe conferiu conhecimento e
          experiência sobre o funcionamento de uma empresa.
          <br /><br />
          Como aluno da Fundação Educere, Sidimar tentou desenvolver vários
          projetos como esterelizador de ar e uma bomba de infusão. Mas o
          primeiro produto que desenvolveu foi um clareador dental a laser
          quando já estava trabalhando na Cristófoli e que foi produzido e
          comercializado pela empresa.
          <br /><br />
          Determinado, em 2010, Sidimar largou sua empresa seu emprego e
          dedicou-se à incubadora de sua empresa Lizze, aplicando a mesma
          tecnologia do clareador dental em um equipamento voltado ao alisamento
          de cabelos. Levou um ano para desenvolver e realizar a primeira venda
          de seu produto, e dois, para sair da Fundação Educere. Com base na
          experiência adquirida, desenvolveu uma linha de Equipamentos
          profissionais voltado para banho e tosa de pets, criando a empresa
          Petlizze, graduada pela Fundação Educere em 2017.
          <br /><br /><br /><br />
          No ano de 2019, a empresa Lizze registrou um crescimento exepcional de
          suas vendas em mais de 100%, ultrapassando R$40 milhões de faturamento
          bruto, com uma equipe de 88 colaboradores.
        </div>
      </div>
    </div>
    <div>
      <div></div>
      <div class="texto-aluno2"></div>
    </div>
  </div>
</section>
